module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "#/c006#TOC"
    }
  }, [_vm._v("Copyright")]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  })]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "189",
      "src": "d2d_images/image006.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.EvolvedPub.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.EvolvedPub.com")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Per essere sicuro di non perdere importanti annunci sui nostri libri, promozioni speciali, ecc., iscriviti alla nostra newsletter all’indirizzo qui sotto. E non temere, non ti manderemo spam, né daremo i tuoi dati ad altri.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d5053e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c002.vue
// module id = 63
// module chunks = 0